module.exports = __webpack_public_path__ + "img/dynamic-20.c652fdbe.png";